function Footer() {
  const ano = new Date().getFullYear();

  return (
    <footer
      style={{
        height: "45px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderTop: "1px solid #ddd",
        fontSize: "13px",
      }}
    >
      SisGecMed © {ano} - Todos os direitos reservados.
    </footer>
  );
}

export default Footer;